export enum ExportStatus {
  DRAFT = "draft",
  NEW = "New",
  INPROGRESS = "In Progress",
  COMPLETED = "Completed",
  FAILED = "Failed",
}

export const VALUE_LIMIT = 100;
export const LATESTVERSION = "Latest";

